export class AuthData {
    username: string;
    token: string;
    accountID: string;
    accounts: string[];
}
